module.exports = __webpack_public_path__ + "20ff4863da10a6e27bdcfe3044d4e003.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/calcalistSample.png
// module id = 3204
// module chunks = 0